import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { shouldCollectCardForRole } from '../../utils/startTrialCheckout';
import api from '../../services/api';
import PageLoader from '../common/PageLoader';

/**
 * Singles/parents must complete Stripe trial setup (card on file) before using the app.
 */
const SubscriptionGate = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();
  const [state, setState] = useState({ loading: true, allowed: false });

  useEffect(() => {
    let cancelled = false;

    if (!user || !shouldCollectCardForRole(user.role)) {
      setState({ loading: false, allowed: true });
      return undefined;
    }

    (async () => {
      try {
        const { data } = await api.get('/stripe/subscription');
        if (cancelled) return;
        const allowed = Boolean(data?.hasBillingAccess || data?.isPro || data?.isTrialing);
        setState({ loading: false, allowed });
      } catch {
        if (!cancelled) setState({ loading: false, allowed: false });
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [user]);

  if (state.loading) return <PageLoader />;

  if (!state.allowed) {
    return (
      <Navigate
        to="/subscription"
        replace
        state={{ from: location.pathname, setupRequired: true }}
      />
    );
  }

  return children;
};

export default SubscriptionGate;
